import { commonStyles } from '../theme';

// You can extend commonStyles for specific components
export const modalStyles = {
  ...commonStyles.modal,
  customModalStyle: {
    // Add custom modal styles
  }
};

export const formStyles = {
  ...commonStyles.formControl,
  customFormStyle: {
    // Add custom form styles
  }
};

export const tableStyles = {
  ...commonStyles,
  customTableStyle: {
    // Add custom table styles
  }
}; 